export class Footer {
  constructor() {
    this.subHeadingsEls = document.querySelectorAll('.js-subHeading');
    this.linksEls = document.querySelectorAll('.js-linksWrapper');
    this.chevrons = document.querySelectorAll('.js-subHeading');
    this.mobileBP = window.matchMedia(`(max-width: 767px)`);
    this.handleBreakpoint();
    this.mobileBP.addListener(this.handleBreakpoint.bind(this));
    this.disclaimerLinks();
    this.setupOneTrustLink();
    this.pauseFooterVideo();
  }

  pauseFooterVideo() {
    let footerVideoEle = document.getElementById("js-footer-video");

    if(footerVideoEle)
      setTimeout(() => footerVideoEle.pause(), 20000);
  }

  handleBreakpoint() {
    if (this.mobileBP.matches) {
      this.enableMobileFooter();
    } else {
      this.resetMobileFooter();
    }
  }

  enableMobileFooter() {
    for (let linkEl of this.linksEls) {
      linkEl.classList.add('js-hide');
    }

    for (let subHeadingEl of this.subHeadingsEls) {
      subHeadingEl.addEventListener('click', (evt) => {
        const headingEl = evt.currentTarget;
        const parentEl = headingEl.closest('.Footer-subFooterWrapper');
        if (!parentEl) { return; }
        const linksEl = parentEl.querySelector('.js-linksWrapper');
        const chevron = parentEl.querySelector('.js-chevron');

        chevron.classList.toggle('js-isActive');
        if(headingEl.classList.contains('js-isOpen')) {
          headingEl.classList.remove('js-isOpen');
          headingEl.setAttribute("aria-expanded", false);
        } else {
          headingEl.classList.add('js-isOpen');
          headingEl.setAttribute("aria-expanded", true);
        }
        if (linksEl) {
          linksEl.classList.toggle('js-hide');
        }
      })
    }
  }

  resetMobileFooter() {
    for (let linkEl of this.linksEls) {
      linkEl.classList.remove('js-hide');
    }

    for (let subHeadingEl of this.subHeadingsEls) {
      subHeadingEl.classList.remove('js-isOpen');
    }
  }

  disclaimerLinks() {
    const disclaimer = document.querySelector('.js-footer-disclaimer');
    const newTabIcon = ` <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                         <path d="M6.40039 0C6.84197 0.000211467 7.20009 0.358197 7.2002 0.799805C7.2002 1.2415 6.84204 1.5994 6.40039 1.59961H1.59961V14.4004H14.4004V9.59961C14.4006 9.15796 14.7585 8.7998 15.2002 8.7998C15.6418 8.79991 15.9998 9.15803 16 9.59961V15.2002C15.9999 15.6419 15.6419 15.9999 15.2002 16H0.799805C0.358132 15.9999 0.0001063 15.6419 0 15.2002V0.799805C0.000105785 0.358132 0.358132 0.000105463 0.799805 0H6.40039ZM15.2021 0C15.4061 0.00060808 15.61 0.078775 15.7656 0.234375C15.8423 0.311076 15.9004 0.399784 15.9395 0.494141C15.9784 0.58831 16 0.691546 16 0.799805V5.59961C16 6.04137 15.6419 6.40028 15.2002 6.40039C14.7584 6.40039 14.4004 6.04144 14.4004 5.59961V2.73145L6.16602 10.9658C5.8536 11.2782 5.3466 11.2782 5.03418 10.9658C4.72176 10.6534 4.72176 10.1464 5.03418 9.83398L13.2686 1.59961H10.4004C9.95856 1.59961 9.59961 1.24163 9.59961 0.799805C9.59971 0.358067 9.95863 -3.86201e-08 10.4004 0H15.2021Z" fill="currentColor"/>
                         </svg>`;
    if (disclaimer) {
      const links = disclaimer.getElementsByTagName('a');
      for (let i = 0; i < links.length; i++) {
        links[i].target = "_blank";
        links[i].insertAdjacentHTML('beforeend', newTabIcon);
      }
    }
  }

  setupOneTrustLink() {
    const otLink = document.querySelector('.js-cookieLink');
    if (otLink) {
      otLink.addEventListener('click', () => {
        window.OneTrust.ToggleInfoDisplay();
      })
    }
  }
}
